import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'

import { LoaderOverlay } from 'cng-common/components/loaderOverlay'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button/Button'
import { Controller, isEmpty, ValidateInput } from 'core-components/library/validation'
import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { IQBRDocumentsListItem } from 'partner360/models/qbr/IQBRDocumentsListItem'

import { cloneQbrDocument } from '../../../../../../services/qbr/cloneQbrDocument'
import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './QbrCloneVersion.module.scss'

interface IProps {
  selectedVersion: IQBRDocumentsListItem
  closeDialog: () => void
  qbrDocumentsData: IQBRDocumentsListItem[]
  setQbrDocumentsData: (value: IQBRDocumentsListItem[]) => void
}

export const QbrCloneVersionContent = ({
  selectedVersion,
  closeDialog,
  qbrDocumentsData,
  setQbrDocumentsData,
}: IProps) => {
  const [versionName, setVersionName] = useState('')
  const [wip, setWip] = useState(false)
  const user = useSelector(selectUser)

  const onSave = useCallback(async () => {
    setWip(true)
    const newItem = await cloneQbrDocument({
      documentId: selectedVersion.EntryId,
      name: versionName,
    })
    setQbrDocumentsData([
      ...qbrDocumentsData,
      { ...selectedVersion, EntryId: newItem.EntryId, CreatedBy: user.id, Name: newItem.Name },
    ])
    setWip(false)
    closeDialog()
  }, [selectedVersion, closeDialog, versionName, qbrDocumentsData, user.id, setQbrDocumentsData])

  return (
    <Controller>
      <LoaderOverlay isVisible={wip} />
      <div className={styles.title}>
        <Translation text={TRANSLATION_KEYS.qbrCloneDialog.cloneRecordTitle} />
      </div>
      <ValidateInput
        label={<Translation text={TRANSLATION_KEYS.qbrCloneDialog.inputPlaceholder} />}
        checkFn={isEmpty}
        value={versionName}
        onChange={setVersionName}
      />
      <div className={styles.btnWrapper}>
        <Button onClick={onSave} disabled={!versionName}>
          <Translation text={TRANSLATION_KEYS.qbrCloneDialog.saveButton} />
        </Button>
      </div>
    </Controller>
  )
}
